<template>

    <div>

        <h3>{{ package_.display_name }}</h3>

        <hr>

        <h4 class="mt-5">{{ t.__('Zestawy') }}</h4>

        <button class="btn btn-sm btn-primary" @click="addSet()">{{ t.__('Dodaj zestaw') }}</button>

        <div class="set-elements-row mt-4">
            <div class="set-element-wrapper" v-for="(set, index) in sets" :key="index" v-bind:class="{ selected: (selectedSet && selectedSet.id === set.id) }" @click="selectSet(set)">
                <img v-if="set.icon_url" :src="set.icon_url" alt="" class="set-icon">
                <div class="set-name text-truncate" :title="set.display_name">{{ set.display_name }}</div>
                <div class="action-buttons" @click="selectSet(set)">
                    <a href="javascript:void(0);" :title="t.__('Edytuj')" class="text-primary edit" @click="editSet(set)">
                        <i class="fa fa-pencil-square-o"></i>
                    </a>
                    <a href="javascript:void(0);" :title="t.__('Usuń')" class="text-danger delete" @click="deleteSet(set)">
                        <i class="fa fa-trash"></i>
                    </a>
                </div>
            </div>
        </div>

        <p class="my-3">{{ t.__('Wybierz zestaw aby zobaczyć jego gry.') }}</p>

        <div v-if="selectedSet">

            <h4 class="mt-5">{{ t.__('Gry wybranego zestawu') }}</h4>

            <button class="btn btn-sm btn-primary" @click="addGame()">{{ t.__('Dodaj grę') }}</button>

            <div class="mt-4">
                <div class="game-element-wrapper" v-for="(game, index) in selectedSet.games" :key="index">
                    <img v-if="game.icon_url" :src="game.icon_url" alt="" class="game-icon">
                    <div class="game-name text-truncate" :title="game.display_name">{{ game.display_name }}</div>
                    <div class="action-buttons text-right">
                        <a :href="route('customer::game-content.prepare-files', {id: game.id})" v-if="game.base_game.editor !== null" :title="t.__('Edytuj zawartość')" class="text-primary edit-content">
                            <i class="fa fa-list-ul"></i>
                        </a>
                        <a href="javascript:void(0);" v-if="game.base_game.editor !== null" :title="t.__('Edytuj')" class="text-primary edit" @click="editGame(game)">
                            <i class="fa fa-pencil-square-o"></i>
                        </a>
                        <a href="javascript:void(0);" :title="t.__('Usuń')" class="text-danger delete" @click="deleteGame(game)">
                            <i class="fa fa-trash"></i>
                        </a>
                    </div>
                </div>
            </div>

        </div>

        <package-content-set-modal :package_="package_"></package-content-set-modal>
        <package-content-game-modal :package_="package_"></package-content-game-modal>

    </div>

</template>

<script>
    export default {

        name: 'PackageContent',

        props: [
            'package_',
            'setsInput'
        ],

        data() {
            return {
                eventHub: window.eventHub,
                sets: null,
                selectedSet: null
            }
        },

        created () {
            this.eventHub.$on('package-content-send-to-machine', () => {
                this.sendToMachine();
            })
        },

        beforeDestroy () {
            this.eventHub.$off('package-content-send-to-machine')
        },

        beforeMount() {

            this.sets = this.setsInput;

        },

        mounted() {

            // Package content was updated
            this.eventHub.$on('package-content-updated', (sets = null) => {
                if (sets) {
                    this.sets = sets;
                }

                this.selectedSet = this.sets.find(set => {
                    return set.id === this.selectedSet.id
                });

                this.$forceUpdate(); // ? check if necessary
            });

        },

        methods: {

            addSet() {
                this.eventHub.$emit('package-content-add-set');
            },

            editSet(set) {
                this.eventHub.$emit('package-content-edit-set', set);
            },

            deleteSet(set) {
                this.$bvModal.msgBoxConfirm(t.__('Czy na pewno chcesz usunąć zestaw') + ': ' + set.display_name + '?', {
                    title: t.__('Usuń zestaw'),
                    size: 'sm',
                    okVariant: 'danger',
                    okTitle: t.__('Usuń'),
                    cancelTitle: t.__('Anuluj'),
                    hideHeaderClose: false,
                    centered: true
                })
                    .then(value => {
                        if (value) {
                            this.eventHub.$emit('processing-start');
                            this.selectedSet = null;
                            axios.delete(route('customer::package-content.delete-set', {packageId: this.package_.id, id: set.id}))
                                .then(response => {
                                    this.eventHub.$emit('package-content-updated', response.data.data.sets);
                                    this.eventHub.$emit('processing-finish');
                                    this.eventHub.$emit('toast-notification', response.data.message, 'success');
                                })
                                .catch(error => {
                                    console.log(error);
                                    this.eventHub.$emit('processing-finish');
                                    this.eventHub.$emit('toast-notification', t.__('Coś poszło nie tak.'), 'error');
                                });
                        }
                    });
            },

            selectSet(set) {
                this.selectedSet = set;
            },

            addGame() {
                this.eventHub.$emit('package-content-add-game', this.selectedSet);
            },

            editGame(game) {
                this.eventHub.$emit('package-content-edit-game', game);
            },

            deleteGame(game) {
                this.$bvModal.msgBoxConfirm(t.__('Czy na pewno chcesz usunąć grę') + ': ' + game.display_name + '?', {
                    title: t.__('Usuń grę'),
                    size: 'sm',
                    okVariant: 'danger',
                    okTitle: t.__('Usuń'),
                    cancelTitle: t.__('Anuluj'),
                    hideHeaderClose: false,
                    centered: true
                })
                    .then(value => {
                        if (value) {
                            this.eventHub.$emit('processing-start');
                            this.selectedSet = null;
                            axios.delete(route('customer::package-content.delete-game', {packageId: this.package_.id, id: game.id}))
                                .then(response => {
                                    this.eventHub.$emit('package-content-updated', response.data.data.sets);
                                    this.eventHub.$emit('processing-finish');
                                    this.eventHub.$emit('toast-notification', response.data.message, 'success');
                                })
                                .catch(error => {
                                    console.log(error);
                                    this.eventHub.$emit('processing-finish');
                                    this.eventHub.$emit('toast-notification', t.__('Coś poszło nie tak.'), 'error');
                                });
                        }
                    });
            },

            sendToMachine() {
                axios.get(route('customer::package-content.send-to-machine', {packageId: this.package_.id}))
                    .then(response => {
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', response.data.message, 'success');
                    })
                    .catch(error => {
                        console.log(error);
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', t.__('Coś poszło nie tak.'), 'error');
                    });
            }

        }

    }
</script>

<style scoped>

    .set-elements-row {
        margin-left: -7px;
        padding: 7px;
        overflow-x: auto;
        white-space: nowrap;
    }

    .set-element-wrapper {
        display: inline-flex;
        margin-right: 15px;
        width: 200px;
        height: 310.66px;
        position: relative;
        border-radius: 7px;
        background: #ededed;
        cursor: pointer;
    }

    .set-element-wrapper .set-icon {
        width: 100%;
        height: 266.66px;
        border-top-left-radius: 7px;
        border-top-right-radius: 7px;
    }

    .set-element-wrapper .set-name {
        position: absolute;
        left: 0;
        bottom: 0;
        background: #ededed;
        color: black;
        padding: 10px;
        width: 155px;
        border-bottom-left-radius: 7px;
    }

    .set-element-wrapper .action-buttons {
        position: absolute;
        right: 0;
        bottom: 0;
        background: #ededed;
        padding: 10px 10px 10px 0;
        width: 45px;
        border-bottom-right-radius: 7px;
    }

    .set-element-wrapper .action-buttons .edit {
        position: relative;
        top: 2px;
    }

    .set-element-wrapper.selected {
        box-shadow: #3784E6 0 0 5px 5px;
    }

    .game-element-wrapper {
        display: inline-flex;
        margin-right: 15px;
        width: 170px;
        height: 267.46px;
        position: relative;
        border-radius: 7px;
        background: #ededed;
    }

    .game-element-wrapper .game-icon {
        width: 100%;
        height: 226.66px;
        border-top-left-radius: 7px;
        border-top-right-radius: 7px;
    }

    .game-element-wrapper .game-name {
        position: absolute;
        left: 0;
        bottom: 0;
        background: #ededed;
        color: black;
        padding: 10px 10px 10px 5px;
        width: 115px;
        border-bottom-left-radius: 7px;
        font-size: 0.88rem;
    }

    .game-element-wrapper .action-buttons {
        position: absolute;
        right: 0;
        bottom: 0;
        background: #ededed;
        padding: 10px 5px 10px 0;
        width: 55px;
        border-bottom-right-radius: 7px;
        font-size: 0.88rem;
    }

    .game-element-wrapper .action-buttons .edit {
        position: relative;
        top: 1px;
    }

    .game-element-wrapper .action-buttons .edit-content {
        position: relative;
        right: 2px;
        top: 1px;
    }

</style>
